import mixpanel from 'mixpanel-browser';

const mixpanelToken = "dabc8585283965525343c3431fb1dbde";

export const mixpanelInit = () => {
  if (mixpanelToken) {
    mixpanel.init(mixpanelToken, {
      api_host: 'https://drdun9bya6vw5.cloudfront.net',
      persistence: 'localStorage',
      track_pageview: true,
    });
  }
};

function extractOrganizationName(email) {

  if(email){
    const parts = email?.split("@");

  // Check if the split operation resulted in two parts (username and domain)
  if (parts?.length === 2) {
      // Split the domain part by the dot (.) symbol
      const domainParts = parts[1]?.split(".");

      // If domainParts has more than one part, take the first part as the organization name
      if (domainParts?.length > 1) {
          return domainParts[0];
      } else {
          // If domainParts has only one part, return that as the organization name
          return parts[1];
      }
  } else {
      // If the email doesn't contain an "@" symbol, return null
      return null;
  }
  }else{
    return null
  }
}

export const mixpanelAppRegister = (email,name,role,client) => {
  const organisation = extractOrganizationName(email);
  if (mixpanelToken) {
    mixpanel.identify(email);
    mixpanel.people.set('$email', email);
    mixpanel.people.set('$name', name);
    mixpanel.people.set('organisation', organisation)
    mixpanel.people.set('role', role);
    mixpanel.register({
      email: email,
      role: role,
      organisation: organisation,
      client:client,
      tool:"qc_scheduler"
    });
  }
};

export const mixpanelPathnameEvent = (str) => {
  if (mixpanelToken) {
      mixpanel.track(`${str} page visited`);
    }
};

export const mixpanelLoginFunction = (email,name,role,client) => {
  const organisation = extractOrganizationName(email);
  if (mixpanelToken) {
    mixpanel.identify(email);
    mixpanel.people.set('$email', email);
    mixpanel.people.set('$name', name);
    mixpanel.people.set('organisation',organisation);
    mixpanel.people.set('role',role);
    mixpanel.register({
      email: email,
      role: role,
      organisation: organisation,
      client:client,
      tool:"qc_scheduler"
    });
    mixpanel.track('User login', {
      email: email,
    });
  }
};

export const mixpanelTrackTabs = (tab, page) => {
  
  if (mixpanelToken) {
    mixpanel.track('Tab switch', {
      page:page,
      tab: tab,
      tool:"qc_scheduler"
    });
  }
};

export const mixpanelTrackButton = ( page, buttonClicked) => {
  if (mixpanelToken) {
      mixpanel.track('Button clicked', {
      page: page,
      buttonClicked: buttonClicked,
      tool:"qc_scheduler"
    });
  }
};

export const mixpanelTrackTabsButton = ( tab, buttonClicked,page) => { // for tracking buttons in tabs
  if (mixpanelToken) {
      mixpanel.track('Button clicked', {
      tab: tab,
      buttonClicked: buttonClicked,
      page: page,
      tool:"qc_scheduler"
    });
  }
};

export const mixpanelPageView = (page, mode) => {
    mixpanel.track("Page View", {
      page: page,
      mode:mode
    });
  };